export default __webpack_public_path__ + "static/media/problema-04.6f5dc8c1.webp";